export default __webpack_public_path__ + "static/media/upload_avatar.7591b283.svg";